import * as React from 'react';

// Components
import { FancyAvatar } from '../Avatar';
import Typography from '../Typography';

// Component
interface IProps {
  avatarSrc: string | null;
  firstName: string;
  lastName: string;
  comment: string;
  timeLabel: string;
  dangerouslySetInnerHTML?: boolean;
}

function Comment(props: IProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        padding: 16,
        position: 'relative',
        wordBreak: 'break-all'
      }}
    >
      <div style={{ marginRight: 16 }}>
        <FancyAvatar
          text={`${props.firstName} ${props.lastName}`}
          src={props.avatarSrc}
        />
      </div>
      <div style={{ flexGrow: 1, padding: '0 8px' }}>
        <Typography type={'body2'}>
          {`${props.firstName} ${props.lastName}`}
        </Typography>
        <Typography type={'body1'}>
          {props.dangerouslySetInnerHTML ? (
            <span dangerouslySetInnerHTML={{ __html: props.comment }} />
          ) : (
            <span>{props.comment}</span>
          )}
        </Typography>
      </div>
      <div style={{ position: 'absolute', right: 16, top: 16 }}>
        <Typography type={'caption'} noWrap={true} style={{ opacity: 0.8 }}>
          {props.timeLabel}
        </Typography>
      </div>
    </div>
  );
}

export default Comment;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Comment/Comment.tsx